<template>
    <div>
        <div calss="">
            <HomeVue v-if="view == 'home'" />

            <!-- <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 1" @mtdViewFooter="mtdViewFooter" @setView="setView" />
            <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 3" @mtdViewFooter="mtdViewFooter" @setView="setView" /> -->
            <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 4" @mtdViewFooter="mtdViewFooter" @setView="setView" />
        </div>
        <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
    </div>
</template>

<script>
import FooterVue from "../../components/Contador/Footer.vue";
import HomeVue from "../../components/Contador/Home.vue";
import ReportView from '../reports/ReportsView.vue';

export default {
    components: { FooterVue, HomeVue, ReportView},
    data() {
        return {
            view: "home",
        };
    },
    methods: {
        setView: function (payload) {
            this.view = payload;
        },
        mtdViewFooter: function (boo, view) {
            this.booFooter = boo;
            if (boo == true) this.view = view;
        }
    },
};
</script>

<style lang="scss" scoped></style>
